var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottomArrowIcon = function SvgBottomArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M6 8.286a.57.57 0 0 1-.404-.167L2.168 4.69a.57.57 0 1 1 .808-.808L6 6.907l3.024-3.025a.57.57 0 1 1 .808.808L6.404 8.12A.57.57 0 0 1 6 8.286",
    clipRule: "evenodd"
  })));
};
export default SvgBottomArrowIcon;